import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  channelList: [], 
  channel: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const channelSlice = createSlice({
  name: 'channel',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    addChannel(state, action) {
      state.channelList = [action.payload].concat(state.channelList);
      state.error = undefined;
      state.loading = false;
    },
    updateChannel(state, action) {
      state.channelList = state.channelList.map((channel) =>
        channel.id === action.payload.id ? action.payload : channel
      );
      state.error = undefined;
      state.loading = false;
    },
    fetchAllChannelsPageable(state, action) {
      state.channelList = action.payload.content;      
      state.totalElements = action.payload.totalElements;    
      state.error = undefined;
      state.loading = false;
    },
    deleteChannel(state, action) {
      state.channelList = state.channelList.filter(
        (channel) => channel.id !== action.payload
      );  
      state.error = undefined;
      state.loading = false;
    },
    fetchChannelById(state, action) {
      state.channel = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    fetchAllChannels(state, action) {
      state.channelList = action.payload;
      state.error = undefined;
      state.loading = false;
    }, 
  },
});

export const channelActions = channelSlice.actions;

export default channelSlice.reducer;
